
import ContactDataTemplate from "../../components/ContactDataTemplate";
import OceanContactDataTemplate from "../../ocean/oceanComponent/OceanContactDataTemplate";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { useEffect, useState } from "react";
import React from "react";

import ServiceTypeToggle from "../../components/shared/ServiceTypeToggle";

const defaultTheme = createTheme();

const SubscriptionTemplate = () => {
  const scrollContainerRef = React.useRef<HTMLDivElement | null>(null);
  const [isFixed, setIsFixed] = React.useState(false);
  const [originalOffset, setOriginalOffset] = React.useState(0);

  const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");


  useEffect(() => {
    if (scrollContainerRef.current) {
      setOriginalOffset(scrollContainerRef.current.offsetTop);
    }

    const handleScroll = () => {
      if (scrollContainerRef.current) {
        const scrollY = window.scrollY;
        if (scrollY >= originalOffset) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [originalOffset]);

  return (
    <ThemeProvider theme={defaultTheme}>
      {/* ── Sticky header bar ─────────────────────────────────── */}
      <div
        className="fiexddBox"
        ref={scrollContainerRef}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: isFixed ? "white" : "transparent",
          padding: "8px 10px",
          transition: "background-color 0.3s ease",
          position: isFixed ? "sticky" : "relative",
          top: isFixed ? "0px" : "auto",
          left: "0",
          right: "0",
          margin: "0 auto",
          zIndex: 1,
          boxShadow: isFixed ? "0px 2px 4px rgba(0,0,0,0.1)" : "none",
          borderRadius: isFixed ? "15px" : "0px",
        }}
      >
        {/* Left — page title */}
        <h1
          style={{
            fontSize: "20px",
            fontWeight: 700,
            color: "#374151",
            margin: 0,
            lineHeight: 1,
            width: "75%",
            zIndex: 1
          }}
        >
          Subscription Template
        </h1>

        {/* Right — toggle */}
        <ServiceTypeToggle
          onTypeChange={setActiveTab}
          activeTab={activeTab}
          width="25%"
        />
      </div>

      {/* ── Page content ──────────────────────────────────────── */}
      {activeTab === "air" && <ContactDataTemplate />}
      {activeTab === "ocean" && <OceanContactDataTemplate />}
    </ThemeProvider>
  );
};

export default SubscriptionTemplate;